export default "__VITE_ASSET__CRsDwLPp__"